// Check if an address line ends with state and zipcode ", CA 12345"
const ADDRESS_LINE_REGEX = /,?\s*(al|ak|az|ar|ca|co|ct|de|fl|ga|hi|id|il|in|ia|ks|ky|la|me|md|ma|mi|mn|ms|mo|mt|ne|nv|nh|nj|nm|ny|nc|nd|oh|ok|or|pa|ri|sc|sd|tn|tx|ut|vt|va|wa|wv|wi|wy)\s*,?\s*\d{5}\s*$/i;
export function doAddressLinesEndWithStateAndZipcode(address) {
  const addressLine1 = address?.addressLine1;
  if (addressLine1 && ADDRESS_LINE_REGEX.test(addressLine1)) {
    return true;
  }
  const addressLine2 = address?.addressLine2;
  if (addressLine2 && ADDRESS_LINE_REGEX.test(addressLine2)) {
    return true;
  }
  return false;
}